export default __webpack_public_path__ + "media/arrow-pointer.4a8f1b81.png";